import { render, staticRenderFns } from "./purchaseDetailsTypeMap.vue?vue&type=template&id=10bb957a&scoped=true"
import script from "./purchaseDetailsTypeMap.vue?vue&type=script&lang=js"
export * from "./purchaseDetailsTypeMap.vue?vue&type=script&lang=js"
import style0 from "./purchaseDetailsTypeMap.vue?vue&type=style&index=0&id=10bb957a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10bb957a",
  null
  
)

export default component.exports